import { ShieldOutlined, TaskAltOutlined } from "@mui/icons-material";

export const products = [
  {
    name: "Hospital Equipment",
    img: "https://imgs.search.brave.com/9krgSt1d7fZppIneF55BBkn46wUq4voVX-8--gfnyG0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9z/dGlsbC1saWZlLW1l/ZGljYWwtdG9vbHNf/MjMtMjE0OTM3MTI2/My5qcGc_c2VtdD1h/aXNfaHlicmlk",
    description: "Reliable equipment for hospitals and clinics.",
  },
  {
    name: "Oxygen Supply Systems",
    img: "https://imgs.search.brave.com/MvQZmLnz4m7VVeEafwvsgaoBgmkgiXQh6o6mCk5NZW8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9yZXNw/aXJhdG9yeS10aGVy/YXB5LmNvbS93cC1j/b250ZW50L3VwbG9h/ZHMvMjAxNS8xMC9v/eHlnZW4tdGhlcmFw/eS1tYXNrLTJrLTEy/ODB4NjQwLmpwZw",
    description: "Customized oxygen supply installations.",
  },
  {
    name: "Hospital & Office Furniture",
    img: "https://imgs.search.brave.com/fGd16nrpjJX-nKN4-PoQZYvn2N4kIjF7mjYIOwSe3W8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/cGl4YWJheS5jb20v/cGhvdG8vMjAxNi8x/MS8wNi8xMC8zNS9o/b3NwaXRhbC0xODAy/Njc5XzEyODAuanBn",
    description: "Durable and comfortable furniture.",
  },
  {
    name: "Linen Items",
    img: "https://internationallinens.com/wp-content/uploads/2024/06/hotel-bed-sheet.webp",
    description: "High-quality hospital linen supplies.",
  },
  {
    name: "Surgical Disposable Items",
    img: "https://imgs.search.brave.com/XlLFTH6tW-sVAuOR1CzBbZLFPCs7akKtfxjTRaH7xHM/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9v/cnRob3BlZGljLWJh/bmRhZ2UtdHdlZXpl/cnMtbWFzay1zeXJp/bmdlLWl2LWJvdHRs/ZS1ibHVlLWJhY2tn/cm91bmRfMjMtMjE0/Nzg3NDg2OC5qcGc_/c2l6ZT02MjYmZXh0/PWpwZw",
    description: "Sterile and single-use medical supplies.",
  },
  {
    name: "IT Equipment",
    img: "https://imgs.search.brave.com/IrsyuQHfbeNPlPclPxwp4CMQOQsDHUrTmrxpzFE9dIs/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9tZWRpY2FsLXN1/cmdpY2FsLWRpYWdu/b3N0aWMtbGFib3Jh/dG9yeS1lcXVpcG1l/bnRzLTNkLXJlbmRl/cmluZ184MDgzMzct/NDAzMy5qcGc_c2Vt/dD1haXNfaHlicmlk",
    description: "Advanced IT solutions for healthcare.",
  },
];

export const certificates = [
  {
    title: "ISO 9001:2015 Certification",
    description:
      "Certification awarded by American Global Standards, LLC, confirming that Bestech Enterprises' quality management system complies with ISO 9001:2015 standards for the supply and manufacture of medical equipment, IT solutions, chemicals, and hospital and office furniture.",
    icon: TaskAltOutlined,
  },
  {
    title: "ISO 13485:2016 Certification",
    description:
      "Certification awarded by RoyalCert International Registrars, confirming that Bestech Enterprises' management system complies with ISO 13485:2016 standards for the supply and manufacture of medical equipment, IT solutions, chemicals, and hospital and office furniture.",
    icon: ShieldOutlined,
  },
];

export const clients = [
  "District Head Quarter (DHQ) Multan",
  "Allied Hospital Faisalabad",
  "District Head Quarter (DHQ) Nankana Sab",
  "District Head Quarter (DHQ) Rawalpindi",
  "District Head Quarter (DHQ) Sargodha",
  "Children Hospital Multan",
  "District Head Quarter (DHQ) Chiniot",
  "Children Hospital Faisalabad",
  "District Head Quarter (DHQ) Faisalabad",
  "District Head Quarter (DHQ) Vehari",
  "Executive District Officer (H) Bahawalpur",
  "Aziz Fatima Hospital Faisalabad",
  // Duplicate the first few items to ensure smooth loop
  "District Head Quarter (DHQ) Multan",
  "Allied Hospital Faisalabad",
  "District Head Quarter (DHQ) Nankana Sab",
  "District Head Quarter (DHQ) Rawalpindi",
];

export const company = {
  name: "Bestech Enterprises",
  description: `Bestech Enterprises is a premier healthcare solutions provider in
          Pakistan, proudly serving the medical community since 2000.
          Specializing in the import and distribution of advanced medical
          equipment, instruments, and consumables, we cater to the needs of
          hospitals and medical institutions across the country. Our expertise
          spans endoscopy, cardiology, operation theatre setups, ward furniture,
          sterilization systems, central gas systems, and more. With a steadfast
          commitment to quality, innovation, and customer satisfaction, we aim
          to deliver reliable, timely, and cost-effective healthcare solutions
          that exceed expectations.`,
  number: "0322-8669382 | 0331-8669382",
  email1: "info@bestechenterprises.com",
  email2: "naseer@bestechenterprises.com",
  address1: "Basement Hameed Chowk D-Ground Peoples Colony Fsd. Pakistan",
  address2: "T-4, Rakshanda Heights, 8km Main Multan Road, Lahore.",
};

export const gradientColor = "linear-gradient(135deg,#2c82ad,#67b26f)";
